import "./Solutions.module.css";
import NavigationPortal from "@/reusable_sections/Header";
import ScalableInfrastructure from "./sections/ScalableInfrastructure";
import ServiceProcess from "./sections/ServiceProcess";
import TheSignatureRequest from "./sections/TheSignatureRequest";
import Footer from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <NavigationPortal />
      <ScalableInfrastructure />
      <ServiceProcess />
      <TheSignatureRequest />
      <Footer />
    </div>;
}